export class SchemaTranslations {
  constructor(private translations: any) {}

  public getFieldTranslation(fieldName: string): string {
    return this.translations[fieldName];
  }

  public getEnumTranslation(fieldName: string, enumName: string): string {
    return this.translations[`${fieldName}.${enumName}`];
  }

}
